import { Drawer } from "@mui/material";
import "./styles.scss";

type Props = {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
};

function SideDrawer({ children, open, onClose }: Props) {
  return (
    <Drawer
      className="sideDrawer"
      anchor="left"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          padding: "24px 16px",
          width: 240,
          gap: "16px",
          display: "flex",
          background:
            "linear-gradient(111.68deg, rgba(255,255,255,0.95) 7.59%, rgba(255,255,255,0.95) 102.04%)",
        },
      }}
      sx={{ zIndex: 10000 }}
    >
      {children}
    </Drawer>
  );
}

export default SideDrawer;
